import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { App } from 'app/app';
import { captureWidgetSelector } from 'app/shared/hooks/use-widget-selector';
import { captureLaunchUrl } from 'app/shared/hooks/use-launch-url';
import { closeSigninReturn } from 'app/shared/utils/close-signin-return';

// Mindbody sends the sign-in window back to our origin once the user authenticates. That
// document has no launch params, so booting the app there just renders the error page inside
// the popup — close it instead and let the dialog resume. Must run before anything else.
if (!closeSigninReturn()) {
  // Persist the widgetId selector and the full launch URL now, while the URL query is intact —
  // the SDK redirect (/?params -> /mbo-widgets) strips it before any page renders.
  captureWidgetSelector();
  captureLaunchUrl();

  const root = createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}
